<template>
  <v-container>
    <v-card class="dt-border pad-10" flat>
      <v-container>
        <v-row class="pa-5 mb-5">
          <div>
            <h2>{{title}}</h2>
          </div>
          <v-spacer></v-spacer>
          <div>
            <giftcard-modal v-if="can('can_manage_giftcards')" @reload = "reload"></giftcard-modal>
          </div>
        </v-row>
        <dtunes-loader :loading="loading"></dtunes-loader>
        <giftcard-table @reload = "reload" :details="details"></giftcard-table>
        <dtunes-empty v-if="details.length == 0 && this.loading == false">
          <template v-slot:title>
            No Registered Giftcard in this store
          </template>
          <template v-slot:sub-title>
            Click on the create giftcard button to create a Giftcard
          </template>
        </dtunes-empty>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
// =============== IMPORT COMPONENTS ============
import GiftcardModal from "../../components/giftcard-modal.vue";
import GiftcardTable from "../../components/giftcard-trade.vue";
import DtunesLoader from "@/components/dtunes-loader.vue";
import DtunesEmpty from "@/components/dtunes-empty.vue"

// =============== IMPORT SERVICES ==============
import { StoresService } from '@/services';

export default {
    data:() =>({
       details:[],
       loading:false,
       title: 'Giftcard'

    }),
  components: {
    GiftcardModal,
    GiftcardTable,
    DtunesLoader,
    DtunesEmpty
  },
  mounted(){
    this.loadTitle();
    this.loadGiftcards();
  },
  methods: {
    loadTitle(){
      this.title = this.$store.state.currentGiftcard
    },
    async loadGiftcards(){
      try {
        this.loading=true
        const data = await StoresService.loadGiftcards({
          store : this.$route.params.id
        });
        console.log(data, "data");
        this.loading=false
        this.details = data;
      } catch (error) {
        this.loading=false
        console.log(error);
      }
    },
    async reload(){
      await this.loadGiftcards()
    }
  },
  beforeDestroy(){
    // RE-FACTOR 

  }

};
</script>

<style scoped>

</style>